import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Onboarding from "@/pages/Onboarding";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import VendorPayout from "@/pages/VendorPayout";

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        richColors
        toastOptions={{
          style: {
            fontFamily: "Manrope, sans-serif",
            border: "1px solid #E2D5C4",
            background: "#FDFBF7",
            color: "#3B1713",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Onboarding />} />
          <Route path="/vendor/payout/:token" element={<VendorPayout />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/vendors/:id" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
